import { useState } from 'react';
import useSWR from 'swr';

export function useCart() {
  return useSWR(
    '/semiprotected/api/checkout/state-api/v2/cart',
    async (...args): Promise<string> => {
      const response = await fetch(...args);

      return await response.json();
    },
    {
      errorRetryInterval: 1000,
      errorRetryCount: 3,
    },
  );
}

export function useAddMembershipToCart(
  initialStateCart: boolean = false,
  onAddToCartSuccess: () => void = () => {},
  onRemoveFromCartSuccess: () => void = () => {},
) {
  const [isMembershipAddedToCart, setIsMembershipAddedToCart] = useState(initialStateCart);

  const addMembershipToCart = async (articleId?: number) => {
    if (articleId) {
      try {
        const response = await fetch(
          `/semiprotected/api/checkout/state-api/v2/add-loyalty-management-article/${articleId}`,
          {
            method: 'PATCH',
          },
        );
        if (response.status === 200) {
          setIsMembershipAddedToCart(true);
          onAddToCartSuccess();
          return;
        }
      } catch (error: unknown) {
        if (error instanceof Error) {
          console.log(error.message, error);
        }
        throw error;
      }
    }
    throw new Error('No articleId provided');
  };

  const removeMembershipFromCart = async () => {
    await fetch('/semiprotected/api/checkout/state-api/v2/remove-loyalty-management-article', {
      method: 'DELETE',
    })
      .then((response) => {
        if (response.status === 200) {
          setIsMembershipAddedToCart(false);
          onRemoveFromCartSuccess();
        }
      })
      .catch((error) => {
        console.log(error.message, error);
      });
  };

  return {
    isMembershipAddedToCart,
    addMembershipToCart,
    removeMembershipFromCart,
  };
}
